/** Inline SVG constants for UI components (rendered via SafeHtmlPipe, not a font/icon library). */
const stroke =
  'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

export const UiIcons = {
  download: `<svg ${stroke}><path d="M12 3v12"/><path d="m7 12 5 5 5-5"/><path d="M5 21h14"/></svg>`,
  upload: `<svg ${stroke}><path d="M12 21V9"/><path d="m7 14 5-5 5 5"/><path d="M5 3h14"/></svg>`,
  arrowDown: `<svg ${stroke}><path d="M12 4v16"/><path d="m6 14 6 6 6-6"/></svg>`,
  loader: `<svg class="animate-spin" ${stroke}><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>`,
  search: `<svg ${stroke}><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>`,
} as const;

export type UiIconName = keyof typeof UiIcons;
